export class PatientHistoryGridModel {
  // WARNING: This is a display object. The properties here control the display column headers in the
  // 'Patient History' grid. Only add properties here if we're adding a new column to the grid.
  // Otherwise extend this class for any other usage.
  // id: DisplayProperty;
  subject: DisplayProperty;
  description: DisplayProperty;
  dateOfEvent: DisplayProperty;
  createdDate: DisplayProperty;
  modifiedBy: DisplayProperty;

  constructor(subject?, description?, dateOfEvent?, createdDate?, updatedBy?) {
    // important to define in this order as it determines the order of columns in the UI grid
    // this.id = {dtoPropertyName: 'id', value: id};
    this.subject = { dtoPropertyName: "subject", value: subject };
    this.description = { dtoPropertyName: "description", value: description };
    this.dateOfEvent = { dtoPropertyName: "eventDate", value: dateOfEvent };
    this.createdDate = { dtoPropertyName: "createdDate", value: createdDate };
    this.modifiedBy = { dtoPropertyName: "updatedBy", value: updatedBy };
  }
}

export class DisplayProperty {
  dtoPropertyName: string;
  value: any;
}



// WEBPACK FOOTER //
// ./src/models/patient-chart/patient-history/patient-history-grid-model.ts